import { render, staticRenderFns } from "./screeningItem.vue?vue&type=template&id=795700d6&scoped=true"
import script from "./screeningItem.vue?vue&type=script&lang=js"
export * from "./screeningItem.vue?vue&type=script&lang=js"
import style0 from "./screeningItem.vue?vue&type=style&index=0&id=795700d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795700d6",
  null
  
)

export default component.exports